import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ShipmentFilterEntity } from '../../domain/entities/ShipmentFilterEntity'
export class ShipmentFilterModel extends ShipmentFilterEntity {
  driverId?: number
  regionId?: number
  fromDate?: string
  toDate?: string
  orderUserId?: string
  constructor(dataDto: ShipmentFilterEntity) {
    super()
    mapEntityProperties<ShipmentFilterModel>(this, dataDto, {
      exclude: ['date', 'driver', 'region', 'orderUser'],
      map: {
        driverId: dataDto.driver?.id,
        regionId: dataDto.region?.id,
        fromDate: dataDto.date ? dataDto.date[0] : undefined,
        toDate: dataDto.date ? dataDto.date[1] : undefined,
        orderUserId: dataDto.orderUser?.id
      }
    })
  }
}
